module.exports = __webpack_public_path__ + "static/media/10_r_derevo3_83.65_53.15.a087288d.png";